module.exports = __webpack_public_path__ + "static/media/icon-catalog-shipping-truck.326e6f54.svg";